module.exports = __webpack_public_path__ + "static/media/image3.6e6dcfab.svg";